/**
 * /dashboard/hiring/requisitions — Legacy redirect. Requisitions list
 * lives at /dashboard/hiring/jobs (SOP §1.2); detail / new sibling
 * routes (/requisitions/$id, /requisitions/new) keep their existing
 * URLs but are not yet ported to the Vite SPA (Phase 3f).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/hiring/requisitions/page.tsx
 * (Next.js server redirect → TanStack beforeLoad throw redirect).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/hiring/requisitions/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/hiring/jobs",
      params: { tenantSlug: params.tenantSlug },
    });
  },
});
